import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { Section } from "./Section";
import { guaranteeItems } from "../data/framework";
export function GuaranteeSection() {
  return <Section tone="cream" labelledBy="guarantee-title" narrow cta="Get Facelift Blueprint™ — risk-free for 7 days" data-id="element-160" data-mp="9ttgc9z21wy4">
      <div className="text-center" data-id="element-161" data-mp="euh66sbjs7qr">
        <div className="mx-auto grid h-32 w-32 place-items-center rounded-full border-4 border-gold bg-navy text-white" data-id="element-162" data-mp="ercy3juyorut">
          <div data-id="element-163" data-mp="nu4ablvnvrni">
            <ShieldCheckIcon className="mx-auto h-8 w-8 text-gold-light" aria-hidden="true" data-id="element-164" data-mp="ntm4bxj75z2e" />
            <p className="mt-1 font-serif text-2xl font-bold leading-none" data-id="element-165" data-mp="skcave3d07yo">7-Day</p>
            <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-gold-light" data-id="element-166" data-mp="xjxkqjk2i0q6">Guarantee</p>
          </div>
        </div>
        <h2 id="guarantee-title" className="mt-6 font-serif text-[1.95rem] font-bold leading-tight text-ink sm:text-4xl md:text-5xl" data-id="element-167" data-mp="12k36jj3not0c">
          Try Facelift Blueprint™ for 7 Days
        </h2>
        <p className="mt-3 text-lg text-muted" data-id="element-168" data-mp="25s710gebtb7b">Explore the complete educational system with a 7-day money-back guarantee.</p>
      </div>

      <div className="mt-8 rounded-3xl border border-line bg-white p-5 sm:p-8" data-id="element-169" data-mp="20rizh0sh1byu">
        <p className="text-[17px] leading-relaxed text-ink/90" data-id="element-170" data-mp="1vuit0orpm777">
          I want you to have the opportunity to open the Blueprint and decide whether its structure fits the way you learn.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-gold-dark" data-id="element-171" data-mp="2oh3ljsjx8pcc">During your first seven days, you can:</p>
        <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-172" data-mp="2jler23mrdymw">
          {guaranteeItems.map(g => <li key={g} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-173" data-mp="2eqinc685tmty">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-174" data-mp="2aqrqplvycchi" />
              {g}
            </li>)}
        </ul>
        <p className="mt-6 text-[15px] leading-relaxed text-muted" data-id="element-175" data-mp="32hxxuma3baga">
          If you decide the product isn't right for you, contact us within the seven-day guarantee period according to the purchase
          terms to request a refund.
        </p>
        <p className="mt-4 font-semibold text-ink" data-id="element-176" data-mp="15ltkocn62o3u">
          My goal is simple: I want you to know what you're purchasing and have a fair opportunity to evaluate it.
        </p>
      </div>
    </Section>;
}